<template>
	<div>
		<el-tabs type="border-card" class="maintab" style="overflow: auto">
			<el-tab-pane>
				<span slot="label"
					><i class="iconfont icon-chukuliucheng"></i> 耗材领用统计</span
				>
				<el-card class="searchItemFlex">
						<el-select
							size="mini"
							style="width: 150px"
							clearable
							filterable
							v-model="statParams.sdId"
							placeholder="领用部门">
							<el-option
								v-for="item in supDepList"
								:key="item.sdId"
								:label="item.sdName"
								:value="item.sdId"></el-option>
						</el-select>
						<el-date-picker
							size="mini"
							v-model="statParams.yearStr"
							style="width: 150px"
							type="year"
							value-format="yyyy"
							placeholder="选择年份">
						</el-date-picker>
						<el-button type="primary" size="mini" @click="beginStat"
							><i class="el-icon-data-line"></i>&nbsp;统计生成</el-button
						>
						<el-button type="success" size="mini" @click="exportData" class="right"
							><i class="el-icon-download"></i>&nbsp;导出数据</el-button
						>
				</el-card>
				<el-divider><i class="el-icon-search"></i></el-divider>
				<el-table
					:data="statList"
					ref="statTable"
					height="610"
					size="mini"
					border
					style="width: 100%"
					v-loading="statLoading"
					element-loading-text="拼命加载中"
					element-loading-spinner="el-icon-loading"
					element-loading-background="rgba(255, 255, 255, 0.8)"
					:header-cell-style="{ 'text-align': 'center' }">
					<el-table-column
						label="耗材编号"
						align="center"
						prop="supId"
						width="100"
						sortable></el-table-column>
					<el-table-column
						label="耗材名称"
						align="center"
						prop="supName"
						width="180"
						show-overflow-tooltip
						sortable></el-table-column>
					<el-table-column
						label="耗材类型"
						align="center"
						prop="scName"
						width="110"
						show-overflow-tooltip
						sortable></el-table-column>
					<el-table-column
						label="计量单位"
						align="center"
						prop="suName"
						width="80"></el-table-column>
					<el-table-column
						label="领用部门"
						align="center"
						prop="sdId"
						width="100"
						show-overflow-tooltip
						sortable>
						<template slot-scope="scope">
							{{ getSdName(scope.row.sdId) }}
						</template>
					</el-table-column>
					<el-table-column label="数量">
						<el-table-column label="1月" align="center">
							<template slot-scope="scope">
								<el-tag
									size="mini"
									:type="scope.row.monthNum[0] > 0 ? 'primary' : 'info'"
									>{{ scope.row.monthNum[0] }}</el-tag
								>
							</template>
						</el-table-column>
						<el-table-column label="2月" align="center">
							<template slot-scope="scope">
								<el-tag
									size="mini"
									:type="scope.row.monthNum[1] > 0 ? 'primary' : 'info'"
									>{{ scope.row.monthNum[1] }}</el-tag
								>
							</template>
						</el-table-column>
						<el-table-column label="3月" align="center">
							<template slot-scope="scope">
								<el-tag
									size="mini"
									:type="scope.row.monthNum[2] > 0 ? 'primary' : 'info'"
									>{{ scope.row.monthNum[2] }}</el-tag
								>
							</template>
						</el-table-column>
						<el-table-column label="4月" align="center">
							<template slot-scope="scope">
								<el-tag
									size="mini"
									:type="scope.row.monthNum[3] > 0 ? 'primary' : 'info'"
									>{{ scope.row.monthNum[3] }}</el-tag
								>
							</template>
						</el-table-column>
						<el-table-column label="5月" align="center">
							<template slot-scope="scope">
								<el-tag
									size="mini"
									:type="scope.row.monthNum[4] > 0 ? 'primary' : 'info'"
									>{{ scope.row.monthNum[4] }}</el-tag
								>
							</template>
						</el-table-column>
						<el-table-column label="6月" align="center">
							<template slot-scope="scope">
								<el-tag
									size="mini"
									:type="scope.row.monthNum[5] > 0 ? 'primary' : 'info'"
									>{{ scope.row.monthNum[5] }}</el-tag
								>
							</template>
						</el-table-column>
						<el-table-column label="7月" align="center">
							<template slot-scope="scope">
								<el-tag
									size="mini"
									:type="scope.row.monthNum[6] > 0 ? 'primary' : 'info'"
									>{{ scope.row.monthNum[6] }}</el-tag
								>
							</template>
						</el-table-column>
						<el-table-column label="8月" align="center">
							<template slot-scope="scope">
								<el-tag
									size="mini"
									:type="scope.row.monthNum[7] > 0 ? 'primary' : 'info'"
									>{{ scope.row.monthNum[7] }}</el-tag
								>
							</template>
						</el-table-column>
						<el-table-column label="9月" align="center">
							<template slot-scope="scope">
								<el-tag
									size="mini"
									:type="scope.row.monthNum[8] > 0 ? 'primary' : 'info'"
									>{{ scope.row.monthNum[8] }}</el-tag
								>
							</template>
						</el-table-column>
						<el-table-column label="10月" align="center">
							<template slot-scope="scope">
								<el-tag
									size="mini"
									:type="scope.row.monthNum[9] > 0 ? 'primary' : 'info'"
									>{{ scope.row.monthNum[9] }}</el-tag
								>
							</template>
						</el-table-column>
						<el-table-column label="11月" align="center">
							<template slot-scope="scope">
								<el-tag
									size="mini"
									:type="scope.row.monthNum[10] > 0 ? 'primary' : 'info'"
									>{{ scope.row.monthNum[10] }}</el-tag
								>
							</template>
						</el-table-column>
						<el-table-column label="12月" align="center">
							<template slot-scope="scope">
								<el-tag
									size="mini"
									:type="scope.row.monthNum[11] > 0 ? 'primary' : 'info'"
									>{{ scope.row.monthNum[11] }}</el-tag
								>
							</template>
						</el-table-column>
						<el-table-column label="总计" align="center">
							<template slot-scope="scope">
								<el-tag size="mini" type="success">{{
									getSum(scope.row.monthNum)
								}}</el-tag>
							</template>
						</el-table-column>
					</el-table-column>
				</el-table>
			</el-tab-pane>

			<el-tab-pane>
				<span slot="label"
					><i class="iconfont icon-ruku1"></i> 耗材入库统计</span
				>
				<el-card class="searchItemFlex">
					<!--库存查询-->
					<el-select
						v-model="suppliesInParams.supId"
						placeholder="耗材库存"
						clearable
						filterable
						size="mini"
						style="width: 140px">
						<el-option
							v-for="item in suppliesList"
							:key="item.supId"
							:label="item.supName"
							:value="item.supId"></el-option>
					</el-select>
					<el-input
						size="mini"
						v-model="suppliesInParams.vendor"
						placeholder="供货商"
						clearable
						style="width: 140px"></el-input>
					<el-date-picker
						v-model="suppliesInParams.siTime"
						size="mini"
						type="datetime"
						placeholder="入库时间"
						style="width: 180px">
					</el-date-picker
					>
					<el-select
						size="mini"
						v-model="suppliesInParams.timeType"
						style="width: 80px">
						<el-option label="之前" :value="0"></el-option>
						<el-option label="之后(含)" :value="1"></el-option>
					</el-select>
					<el-select
						v-model="suppliesInParams.sier"
						clearable
						filterable
						size="mini"
						placeholder="入库人"
						style="width: 140px">
						<el-option
							v-for="item in userList"
							:key="item.userId"
							:label="item.userName"
							:value="item.userId"></el-option>
					</el-select>
					<el-input-number
						v-model="suppliesInParams.siNum"
						size="mini"
						placeholder="入库数量"
						style="width: 140px"></el-input-number>
					<el-button
						type="primary"
						plain
						size="mini"
						@click="suppliesInSearch"
						><i class="el-icon-search"></i>&nbsp;查询</el-button
					>
					<el-button size="mini" plain type="warning" @click="resetInSearch"
						><i class="el-icon-refresh"></i>&nbsp;重置</el-button
					>
					<el-button
						size="mini"
						plain
						type="success"
						@click="exportSuppliesIn"
						><i class="el-icon-download"></i> &nbsp;导出数据</el-button
					>
					<el-tooltip
						content="仅限导出当前显示页的数据，可通过调整页面数据条数限制和切换页来导出相应的数据,单次导出上限为1000条。"
						placement="top"
						effect="light">
						<i class="el-icon-warning"></i>
					</el-tooltip>
				</el-card>
				<el-divider><i class="el-icon-search"></i></el-divider>
				<el-table
					:data="suppliesInList"
					ref="suppliesInTable"
					id="suppliesInTable"
					size="mini"
					border
					height="550"
					style="width: 100%"
					v-loading="suppliesInLoading"
					@sort-change="suppliesInSortChange"
					element-loading-text="拼命加载中"
					element-loading-spinner="el-icon-loading"
					element-loading-background="rgba(255, 255, 255, 0.8)">
					<el-table-column type="index" width="50"> </el-table-column>
					<el-table-column
						label="耗材名称"
						prop="supName"
						show-overflow-tooltip
						width="160"></el-table-column>
					<el-table-column
						label="耗材类型"
						prop="scName"
						show-overflow-tooltip
						width="130"></el-table-column>
					<el-table-column
						label="入库数量"
						prop="siNum"
						:sortable="'custom'"
						width="100">
						<template slot-scope="scope">
							<el-tag size="mini" type="success">{{ scope.row.siNum }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column
						label="耗材单位"
						prop="suName"
						show-overflow-tooltip
						width="100"></el-table-column>
					<el-table-column
						label="入库时间"
						prop="siTime"
						:sortable="'custom'"
						width="160">
						<template slot-scope="scope">
							<el-tag size="mini" type="info">{{
								scope.row.siTime | dateformatAll("YYYY-MM-DD HH:mm:ss")
							}}</el-tag>
						</template>
					</el-table-column>
					<el-table-column
						label="耗材价格"
						prop="price"
						:sortable="'custom'"
						width="110">
						<template slot-scope="scope">
							<el-tag size="mini" type="warning">{{ scope.row.price }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="入库人" prop="xmname" width="100">
						<template slot-scope="scope">
							<el-tag size="mini" type="primary">
								{{ scope.row.xmname }}</el-tag
							>
						</template>
					</el-table-column>
					<el-table-column
						label="供应商"
						prop="vendor"
						show-overflow-tooltip
						width="160">
					</el-table-column>
					<el-table-column label="备注" prop="notes" show-overflow-tooltip>
					</el-table-column>
				</el-table>
				<!--分页部分-->
				<el-pagination
					background
					@size-change="suppliesInPagesizeChange"
					@current-change="suppliesInPagenumChange"
					:current-page="suppliesInParams.pageNum"
					:page-sizes="[50, 100, 200, 500, 1000]"
					:page-size="suppliesInParams.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="suppliesInTotal"
					style="margin-top: 10px">
				</el-pagination>
			</el-tab-pane>

			<el-tab-pane>
				<span slot="label"
					><i class="iconfont icon-xiaoshouchuku"></i> 耗材出库统计</span
				>
				<el-card class="searchItemFlex">
					<!--库存查询-->
					<el-select
						v-model="suppliesOutInfoParams.supId"
						placeholder="耗材库存"
						clearable
						filterable
						size="mini"
						style="width: 140px">
						<el-option
							v-for="item in suppliesList"
							:key="item.supId"
							:label="item.supName"
							:value="item.supId"></el-option>
					</el-select>
					<el-select
						v-model="suppliesOutInfoParams.soDep"
						placeholder="领用部门"
						size="mini"
						clearable
						filterable
						style="width: 140px">
						<el-option
							v-for="item in supDepList"
							:label="item.sdName"
							:value="item.sdId"
							:key="item.sdId"></el-option>
					</el-select>
					<el-date-picker
						v-model="suppliesOutInfoParams.soTime"
						size="mini"
						type="datetime"
						placeholder="出库时间"
						style="width: 180px">
					</el-date-picker
					>
					<el-select
						size="mini"
						v-model="suppliesOutInfoParams.timeType"
						style="width: 80px">
						<el-option label="之前" :value="0"></el-option>
						<el-option label="之后(含)" :value="1"></el-option>
					</el-select>
					<el-input
						size="mini"
						placeholder="领用人"
						clearable
						v-model="suppliesOutInfoParams.soer"
						width="100"></el-input>
					<el-input-number
						v-model="suppliesOutInfoParams.soNum"
						size="mini"
						placeholder="出库数量"></el-input-number>
					<el-button
						type="primary"
						plain
						size="mini"
						@click="suppliesOutSearch"
						><i class="el-icon-search"></i>&nbsp;查询</el-button
					>
					<el-button size="mini" plain type="warning" @click="resetOutSearch"
						><i class="el-icon-refresh"></i>&nbsp;重置</el-button
					>
					<el-button
						size="mini"
						plain
						type="success"
						@click="exportSuppliesOut"
						><i class="el-icon-download"></i> &nbsp;导出数据</el-button
					>
					<el-tooltip
						content="仅限导出当前显示页的数据，可通过调整页面数据条数限制和切换页来导出相应的数据,单次导出上限为1000条。"
						placement="top"
						effect="light">
						<i class="el-icon-warning"></i>
					</el-tooltip>
				</el-card>
				<el-divider><i class="el-icon-search"></i></el-divider>
				<el-table
					:data="suppliesOutList"
					ref="suppliesOutTable"
					id="suppliesOutTable"
					size="mini"
					border
					height="550"
					style="width: 100%"
					v-loading="suppliesOutLoading"
					@sort-change="suppliesOutSortChange"
					element-loading-text="拼命加载中"
					element-loading-spinner="el-icon-loading"
					element-loading-background="rgba(255, 255, 255, 0.8)">
					<el-table-column type="index" width="50"> </el-table-column>
					<el-table-column
						label="耗材名称"
						prop="supName"
						show-overflow-tooltip
						width="160"></el-table-column>
					<el-table-column
						label="耗材类型"
						prop="scName"
						show-overflow-tooltip
						width="130"></el-table-column>
					<el-table-column
						label="出库数量"
						prop="soNum"
						:sortable="'custom'"
						width="100">
						<template slot-scope="scope">
							<el-tag size="mini" type="success">{{ scope.row.soNum }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column
						label="耗材单位"
						prop="suName"
						show-overflow-tooltip
						width="100"></el-table-column>
					<el-table-column
						label="出库时间"
						prop="soTime"
						:sortable="'custom'"
						width="160">
						<template slot-scope="scope">
							<el-tag size="mini" type="info">{{
								scope.row.soTime | dateformatAll("YYYY-MM-DD HH:mm:ss")
							}}</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="领用人" prop="soer" width="100">
						<template slot-scope="scope">
							<el-tag size="mini" type="primary"> {{ scope.row.soer }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column
						label="领用部门"
						prop="sdName"
						show-overflow-tooltip
						width="160">
					</el-table-column>
					<el-table-column label="备注" prop="notes" show-overflow-tooltip>
					</el-table-column>
				</el-table>
				<!--分页部分-->
				<el-pagination
					background
					@size-change="suppliesOutPagesizeChange"
					@current-change="suppliesOutPagenumChange"
					:current-page="suppliesOutInfoParams.pageNum"
					:page-sizes="[50, 100, 200, 500, 1000]"
					:page-size="suppliesOutInfoParams.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="suppliesOutTotal"
					style="margin-top: 10px">
				</el-pagination>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import dayjs from "dayjs"
import FileSaver from "file-saver"
import XLSX from "xlsx"
export default {
	name: "suppliesStatistic",
	data() {
		return {
			statParams: {
				sdId: "",
				yearStr: null,
			}, //统计参数
			supDepList: [], //领用部门列表
			statList: [], //统计数据列表
			statLoading: false, //加载动画
			//入库统计
			suppliesInParams: {
				supId: "",
				vendor: "",
				siTime: null,
				timeType: 0,
				sier: "",
				siNum: undefined,
				order: 0,
				pageSize: 50,
				pageNum: 1,
			}, //入库查询参数
			suppliesList: [], //库存列表
			userList: [], //用户列表
			suppliesInList: [], //入库记录列表
			suppliesInTotal: 0, //入库记录总数
			suppliesInLoading: false, //入库记录加载动画
			//出库统计
			suppliesOutInfoParams: {
				supId: "",
				soDep: "",
				soer: "",
				soNum: undefined,
				soTime: null,
				timeType: 0,
				order: 0,
				pageSize: 50,
				pageNum: 1,
			}, //出库记录查询参数
			suppliesOutList: [], //出库记录
			suppliesOutTotal: 0, //出库记录总数
			suppliesOutLoading: false, //加载动画
			soDepList: [], //领用部门列表
		}
	},
	mounted() {
		this.getSupDepLsit()
		this.getSuppliesAll()
		this.getUserList()
		this.getSuppliesIn()
		this.getSuppliesOut()
	},
	methods: {
		//获取出库领用部门列表
		async getSupDepLsit() {
			const { data: res } = await this.$http.post("/sup/supDepList").catch(err => err)
			if (res) {
				this.supDepList = res
			}
		},
		//执行统计
		async beginStat() {
			//判断参数
			if (this.statParams.yearStr == null) {
				return this.$message.warning("请指定领用部门与年份后再进行统计！")
			} else {
				if (this.statParams.sdId === "") this.statParams.sdId = null
				this.statLoading = true
				const { data: res } = await this.$http.post(
					"/sup/supStat",
					this.statParams
				).catch(err => err)
				if (res) {
					this.statList = res
				}
				this.statLoading = false
			}
		},
		//计算总和
		getSum(param) {
			var sum = 0
			for (var i = 0; i < param.length; i++) {
				sum += param[i]
			}
			return sum
		},
		//导出数据
		exportData() {
			if (this.statList.length <= 0) {
				this.$message.warning("当前无任何数据可导出！")
			} else {
				this.statLoading = true
				this.$notify.info({
					title: "消息",
					message: "正在导出耗材领用统计数据...",
					duration: 2000,
				})
				//导出过程
				//准备数据
				var aoa = []
				//首行标题
				var title = [
					"耗材编号",
					"耗材名称",
					"耗材类型",
					"计量单位",
					"领用部门",
					"数量",
				]
				for (var p = 0; p < 13; p++) {
					title.push(null)
				}
				aoa.push(title)
				aoa.push([
					null,
					null,
					null,
					null,
					null,
					"1月",
					"2月",
					"3月",
					"4月",
					"5月",
					"6月",
					"7月",
					"8月",
					"9月",
					"10月",
					"11月",
					"12月",
					"总计",
				])
				for (var i = 0; i < this.statList.length; i++) {
					var data = []
					data.push(this.statList[i].supId)
					data.push(this.statList[i].supName)
					data.push(this.statList[i].scName)
					data.push(this.statList[i].suName)
					data.push(this.getSdName(this.statList[i].sdId))
					var sum = 0
					for (var j = 0; j < this.statList[i].monthNum.length; j++) {
						data.push(this.statList[i].monthNum[j])
						sum += this.statList[i].monthNum[j]
					}
					//总计
					data.push(sum)
					aoa.push(data)
				}

				//处理单元格合并
				var mergeArr = [
					//A1A2-D1D2 , E1-Q1
					{ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
					{ s: { r: 0, c: 1 }, e: { r: 1, c: 1 } },
					{ s: { r: 0, c: 2 }, e: { r: 1, c: 2 } },
					{ s: { r: 0, c: 3 }, e: { r: 1, c: 3 } },
					{ s: { r: 0, c: 4 }, e: { r: 1, c: 4 } },
					{ s: { r: 0, c: 5 }, e: { r: 0, c: 18 } },
				]

				//表名
				var dateNow = new Date()
				var dep = "全部领用部门"
				if (this.statParams.sdId !== null && this.statParams.sdId !== "")
					this.supDepList[(parseInt(this.statParams.sdId) - 1).toString()]
						.sdName
				const fileName =
					dep +
					this.statParams.yearStr +
					"年耗材领用数据导出_" +
					dayjs(dateNow).format("YYYYMMDD_HHmmss") +
					".xlsx"
				//sheet名
				const ws_name = "数据导出"
				const wb = XLSX.utils.book_new()
				const ws = XLSX.utils.aoa_to_sheet(aoa)
				ws["!merges"] = mergeArr
				XLSX.utils.book_append_sheet(wb, ws, ws_name)
				XLSX.writeFile(wb, fileName)
				//导出完成
				this.$notify({
					title: "成功",
					message: "数据已成功导出！",
					type: "success",
					duration: 2000,
				})
				this.statLoading = false
			}
		},
		//获取领用部门名称
		getSdName(sdId) {
			return this.supDepList[sdId - 1].sdName
		},
		//获取入库记录
		async getSuppliesIn() {
			this.suppliesInLoading = true
			const params = {
				supId: this.suppliesInParams.supId,
				vendor: this.suppliesInParams.vendor,
				siTime: this.suppliesInParams.siTime,
				timeType: this.suppliesInParams.timeType,
				sier: this.suppliesInParams.sier,
				siNum:
					this.suppliesInParams.siNum === undefined
						? null
						: this.suppliesInParams.siNum,
				order: this.suppliesInParams.order,
				pageSize: this.suppliesInParams.pageSize,
				pageNum: this.suppliesInParams.pageNum,
			}
			const { data: res } = await this.$http.post("/sup/supInList", params).catch(err => err)
			if (res) {
				this.suppliesInList = res.suppliesInInfoList
				this.suppliesInTotal = res.total
			}
			this.suppliesInLoading = false
		},
		//获取用于查询的库存列表
		async getSuppliesAll() {
			const { data: res } = await this.$http.post("/sup/supAll").catch(err => err)
			if (res) {
				this.suppliesList = res
			}
		},
		//获取用户列表
		async getUserList() {
			const { data: res } = await this.$http.post("/user/userList").catch(err => err)
			if (res) {
				this.userList = res
			}
		},
		//查询入库记录
		suppliesInSearch() {
			this.getSuppliesIn()
		},
		//重置入库记录
		resetInSearch() {
			this.suppliesInParams = {
				supId: "",
				vendor: "",
				siTime: null,
				timeType: 0,
				sier: "",
				siNum: undefined,
				order: 0,
				pageSize: 50,
				pageNum: 1,
			}
			this.$refs.suppliesInTable.columns.forEach(item => {
				item.order = ""
			})
			this.getSuppliesIn()
		},
		//入库记录排序，仅时间
		suppliesInSortChange(column) {
			if (column.prop == "siTime") {
				if (column.order == "ascending" || column.order == null) {
					this.suppliesInParams.order = 1
				} else {
					this.suppliesInParams.order = 0
				}
			} else if (column.prop == "siNum") {
				if (column.order == "ascending" || column.order == null) {
					this.suppliesInParams.order = 3
				} else {
					this.suppliesInParams.order = 2
				}
			} else if (column.prop == "price") {
				if (column.order == "ascending" || column.order == null) {
					this.suppliesInParams.order = 5
				} else {
					this.suppliesInParams.order = 4
				}
			}
			this.getSuppliesIn()
		},
		//入库记录页面尺寸变化
		suppliesInPagesizeChange(pageSize) {
			this.suppliesInParams.pageNum = 1
			this.suppliesInParams.pageSize = pageSize
			this.getSuppliesIn()
		},
		//入库记录切换页
		suppliesInPagenumChange(newNum) {
			this.suppliesInParams.pageNum = newNum
			this.getSuppliesIn()
		},
		//导出当前入库记录
		exportSuppliesIn() {
			if (this.suppliesInList.length > 0) {
				this.suppliesInLoading = true
				this.$notify.info({
					title: "消息",
					message: "正在导出入库统计数据...",
					duration: 2000,
				})
				var xlsxParam = { raw: true } //转换成excel时，使用原始的格式
				var wb = XLSX.utils.table_to_book(
					document.querySelector("#suppliesInTable"),
					xlsxParam
				) //outTable为列表id
				var wbout = XLSX.write(wb, {
					bookType: "xlsx",
					bookSST: true,
					type: "array",
				})
				try {
					var dateNow = new Date()
					FileSaver.saveAs(
						new Blob([wbout], {
							type: "application/octet-stream;charset=utf-8",
						}),
						"耗材库存入库记录导出_" +
							dayjs(dateNow).format("YYYYMMDD_HHmmss") +
							".xlsx"
					)
				} catch (e) {
					if (typeof console !== "undefined") console.log(e, wbout)
				}
				this.suppliesInLoading = false
				//导出完成
				this.$notify({
					title: "成功",
					message: "数据已成功导出！",
					type: "success",
					duration: 2000,
				})
				return wbout
			} else {
				this.$message.warning("没有可供导出的数据！")
			}
		},
		//获取出库记录
		async getSuppliesOut() {
			this.suppliesOutLoading = true
			const params = {
				supId: this.suppliesOutInfoParams.supId,
				soDep: this.suppliesOutInfoParams.soDep,
				soer: this.suppliesOutInfoParams.soer,
				soNum:
					this.suppliesOutInfoParams === undefined
						? null
						: this.suppliesOutInfoParams.soNum,
				soTime: this.suppliesOutInfoParams.soTime,
				timeType: this.suppliesOutInfoParams.timeType,
				order: this.suppliesOutInfoParams.order,
				pageSize: this.suppliesOutInfoParams.pageSize,
				pageNum: this.suppliesOutInfoParams.pageNum,
			}
			const { data: res } = await this.$http.post("/sup/supOutList", params).catch(err => err)
			if (res) {
				this.suppliesOutList = res.suppliesOutInfoList
				this.suppliesOutTotal = res.total
			}
			this.suppliesOutLoading = false
		},
		//出库记录查询
		suppliesOutSearch() {
			this.getSuppliesOut()
		},
		//重置查询
		resetOutSearch() {
			this.suppliesOutInfoParams = {
				supId: "",
				soDep: "",
				soer: "",
				soNum: undefined,
				soTime: null,
				timeType: 0,
				order: 0,
				pageSize: 50,
				pageNum: 1,
			}
			this.$refs.suppliesOutTable.columns.forEach(item => {
				item.order = ""
			})
			this.getSuppliesOut()
		},
		//导出数据
		exportSuppliesOut() {
			if (this.suppliesOutList.length > 0) {
				this.suppliesOutLoading = true
				this.$notify.info({
					title: "消息",
					message: "正在导出出库记录数据...",
					duration: 2000,
				})
				var xlsxParam = { raw: true } //转换成excel时，使用原始的格式
				var wb = XLSX.utils.table_to_book(
					document.querySelector("#suppliesOutTable"),
					xlsxParam
				) //outTable为列表id
				var wbout = XLSX.write(wb, {
					bookType: "xlsx",
					bookSST: true,
					type: "array",
				})
				try {
					var dateNow = new Date()
					FileSaver.saveAs(
						new Blob([wbout], {
							type: "application/octet-stream;charset=utf-8",
						}),
						"耗材库存出库记录导出_" +
							dayjs(dateNow).format("YYYYMMDD_HHmmss") +
							".xlsx"
					)
				} catch (e) {
					if (typeof console !== "undefined") console.log(e, wbout)
				}
				this.suppliesOutLoading = false
				//导出完成
				this.$notify({
					title: "成功",
					message: "数据已成功导出！",
					type: "success",
					duration: 2000,
				})
				return wbout
			} else {
				this.$message.warning("没有可供导出的数据！")
			}
		},
		//页面尺寸变化
		suppliesOutPagesizeChange(newSize) {
			this.suppliesOutInfoParams.pageSize = newSize
			this.suppliesOutInfoParams.pageNum = 1
			this.getSuppliesOut()
		},
		//页面切换
		suppliesOutPagenumChange(pageNum) {
			this.suppliesOutInfoParams.pageNum = pageNum
			this.getSuppliesOut()
		},
		//出库记录排序
		suppliesOutSortChange(column) {
			if (column.prop == "soTime") {
				if (column.order == "ascending" || column.order == null) {
					this.suppliesOutInfoParams.order = 1
				} else {
					this.suppliesOutInfoParams.order = 0
				}
			} else if (column.prop == "soNum") {
				if (column.order == "ascending" || column.order == null) {
					this.suppliesOutInfoParams.order = 3
				} else {
					this.suppliesOutInfoParams.order = 2
				}
			}
			this.getSuppliesOut()
		},
	},
}
</script>

<style></style>
